/**
 * @desc 查询目录树
 */
import {
  NewsCatalogueEntity,
  NewsCatalogueTreeQuery
} from '@eastcoal/api/content/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryNewsCatalogueTreeParameter = NewsCatalogueTreeQuery

const method = 'GET'
const url = '/content/operation/news/catalogue/tree'

export const queryNewsCatalogueTreeApi = (
  params?: QueryNewsCatalogueTreeParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<Array<NewsCatalogueEntity>>({
    method,
    url,
    params,
    ...config
  })
}

queryNewsCatalogueTreeApi.method = method
queryNewsCatalogueTreeApi.url = url
